import React, { Component } from 'react';
import { inject } from 'mobx-react';
import { Button, Dropdown, Form, Loader, Message } from 'semantic-ui-react';

import Modal from '../Modal';

import '../../css/CreateNewLibraryResourceModal.less';

import { SatCoreComponent, SatCoreRegister } from '../../SatCoreRegistry';

import { DIALOG_NAMES } from '../../managers/DialogManager';

import { stripHtmlTags } from '../../utils';

export default
@inject('assessmentManager', 'libraryManager', 'userManager')
class CreateNewLibraryResourceModal extends Component {
  constructor(props) {
    super(props);
    this.state = this.getInitialState();
    this.ModalBanner = SatCoreComponent('ModalBanner');
    this.SCRadio = SatCoreComponent('SCRadio');
    this.SCCheckbox = SatCoreComponent('SCCheckbox');
  }

  getInitialState = () => {
    return {
      errorMsg: null,
      isValid: false,
      resourceDescription: '',
      resourceName: '',
      resourceUnitName: '',
      resourceTemplate: '',
      originalResourceName: '',
      originalResourceDescription: '',
      selectedModeType: '',
      teacherCanChangeMode: false,
      templateOptions: []
    };
  }

  componentDidMount = async () => {
    const { assessmentManager, contentItemId, isEdit, libraryManager, isReadOnly = false, selectedResourceType } = this.props;
    // Get optionsProfiles to use in the template selection dropdown
    const templateOptions = await libraryManager.getOptionProfiles();
    if (templateOptions && templateOptions.length > 0) {
      this.setState({ templateOptions });
    }
    if ((isEdit || isReadOnly) && contentItemId) {
      // get the resource details
      if (selectedResourceType === 'assessment') {
        const assessmentDetails = await libraryManager.fetchDistrictAssessmentDetails(contentItemId);
        const assessmentName = assessmentDetails?.name ? stripHtmlTags(assessmentDetails.name) : '';
        const assessmentDescription = assessmentDetails?.description ? stripHtmlTags(assessmentDetails.description) : '';
        if (assessmentDetails) {
          this.setState({
            resourceName: assessmentName,
            originalResourceName: assessmentName,
            resourceDescription: assessmentDescription,
            originalResourceDescription: assessmentDescription,
            resourceTemplate: assessmentDetails.optionsProfileId,
            originalResourceTemplate: assessmentDetails.optionsProfileId
          });
        }
      } else if (selectedResourceType === 'course_resource') {
        await assessmentManager.fetchContentItem(contentItemId);
        const assessmentBankDetails = assessmentManager.currentContentItem;
        if (assessmentBankDetails) {
          this.setState({
            resourceName: assessmentBankDetails.name,
            originalResourceName: assessmentBankDetails.name,
            resourceDescription: assessmentBankDetails.description,
            originalResourceDescription: assessmentBankDetails.description
          });
        }
      }
    }
  }

  clearError = () => {
    this.setState({ error: null });
  }

  handleChangeResourceName = async (event) => {
    const resourceName = event.target.value;
    await this.setState({ errorMsg: null, resourceName });
    this.validate();
  }

  handleChangeResourceDescription = async (event) => {
    const resourceDescription = event.target.value;
    await this.setState({ resourceDescription });
    this.validate();
  }

  handleChangeResourceUnitName = async (event) => {
    const resourceUnitName = event.target.value;
    await this.setState({ resourceUnitName });
    this.validate();
  }

  handleChangeResourceTemplate = async (_event, { value }) => {
    const resourceTemplate = value;
    await this.setState({ errorMsg: null, resourceTemplate });
    this.validate();
  }

  handleChangeModeType = async (event) => {
    const selectedModeType = event.target.value;
    this.setState({ selectedModeType });
  }

  handleTeacherCanChangeMode = async (event) => {
    const teacherCanChangeMode = event?.target?.checked;
    this.setState({ teacherCanChangeMode });
  }

  createOrEditLibraryResource = async () => {
    const { assessmentManager, contentItemId, currentMenu, isEdit, libraryManager, selectedResourceType, t } = this.props;
    const { originalResourceDescription, originalResourceName, resourceName, resourceDescription, resourceUnitName, resourceTemplate } = this.state;
    let errorMessageSuffix = '';
    let responseData = null;
    let success = false;
    if (selectedResourceType === 'course_resource' || selectedResourceType === 'assessment-bank') {
      if (isEdit) {
        if (originalResourceName !== resourceName || originalResourceDescription !== resourceDescription) {
          success = await assessmentManager.updateContentItemName(contentItemId, resourceName, resourceDescription);
        }
      } else {
        const resourceUnitNameSave = resourceUnitName || t('defaultUnitPlaceholderText');
        responseData = await libraryManager.createLibraryAssessmentBank(resourceName, resourceDescription, resourceUnitNameSave);
        if (responseData) {
          success = true;
        }
      }
      errorMessageSuffix = t('assessmentBankLabel');
    } else if (selectedResourceType === 'assessment') {
      if (isEdit) {
        success = await libraryManager.updateLibraryAssessment(contentItemId, resourceName, resourceDescription, resourceTemplate);
      } else {
        const addToWorkspace = currentMenu === 'sharedDrafts';
        responseData = await libraryManager.createLibraryAssessment(resourceName, resourceDescription, resourceTemplate, addToWorkspace);
        if (responseData) {
          success = true;
        }
      }
      errorMessageSuffix = 'Assessment';
    }
    if (success) {
      this.closeCreateNewLibraryResourceModal(responseData);
    } else {
      this.showTextMessage(`Error creating ${errorMessageSuffix}.`);
    }
  }

  showTextMessage = (title, message) => {
    const { dialogManager } = this.props;
    if (message) {
      dialogManager.setOpenDialog(DIALOG_NAMES.TEXT, {
        title,
        message
      }, () => dialogManager.closeDialog(DIALOG_NAMES.TEXT));
    }
  }

  validate = async () => {
    const { assessmentManager, isEdit, selectedResourceType } = this.props;
    const { originalResourceDescription, originalResourceName, originalResourceTemplate, resourceTemplate } = this.state;
    let { resourceName, resourceDescription, resourceUnitName } = this.state;
    const entityTypeId = (selectedResourceType === 'assessment') ? 'assessment' : 'course_resource';
    // remove whitespace around values
    resourceName = resourceName.trim();
    resourceDescription = resourceDescription.trim();
    resourceUnitName = resourceUnitName.trim();
    let allRequiredValid = false;
    let nameValid = false;
    let templateValid = false;
    let unitValid = false;
    let anyChanged = false;
    let resourceNameExists = false;

    if (!isEdit || (isEdit && (originalResourceName !== resourceName))) {
      // check for resource name exists but do not exclude hidden from the search as live banks are marked hidden
      resourceNameExists = await assessmentManager.checkContentItemName(resourceName, entityTypeId, false);
      if (resourceNameExists) {
        this.setState({ errorMsg: 'Resource name is already in use.' });
      }
    }
    if (isEdit) {
      let changed = false;
      changed = (originalResourceDescription !== resourceDescription) || (originalResourceName !== resourceName);
      if (changed) {
        // check resource name
        const nameIsChanged = (originalResourceName !== resourceName);
        if (resourceName || resourceName.length > 0) {
          if (!anyChanged && nameIsChanged) {
            if (resourceName.length <= 200) {
              anyChanged = true;
            }
          }
        }
        // check resource description
        const descIsChanged = (originalResourceDescription !== resourceDescription);
        if (resourceDescription && descIsChanged) {
          if (!anyChanged) {
            anyChanged = true;
          }
        }
        // check resource template
        const templateIsChanged = (originalResourceTemplate !== resourceTemplate);
        if (resourceTemplate && templateIsChanged) {
          if (!anyChanged) {
            anyChanged = true;
          }
        }
        // check if resource name exists and override if it is.
        if (nameIsChanged && resourceNameExists) {
          anyChanged = false;
        }
        allRequiredValid = anyChanged;
      }
    } else {
      // for add all only the name need to be valid.
      if (!resourceNameExists) {
        nameValid = !!((resourceName && resourceName.length > 0 && resourceName.length <= 200));
      } else {
        nameValid = false;
      }
      // resource template is now required
      if (selectedResourceType === 'assessment' && (!resourceTemplate || !resourceTemplate.length > 0)) {
        templateValid = false;
      } else {
        templateValid = true;
      }
      // course resource requires unit name
      if (selectedResourceType === 'course_resource' || selectedResourceType === 'assessment-bank') {
        unitValid = !!resourceUnitName;
      }
      if (selectedResourceType === 'assessment') {
        allRequiredValid = (nameValid && templateValid);
      } else {
        allRequiredValid = (nameValid && unitValid);
      }
    }
    this.setState({ isValid: allRequiredValid });
  }

  closeCreateNewLibraryResourceModal = (data = null) => {
    const { closeCreateNewLibraryResourceModal, onCloseCreateNewLibraryResourceModal } = this.props;
    if (onCloseCreateNewLibraryResourceModal) {
      onCloseCreateNewLibraryResourceModal(data);
    }
    closeCreateNewLibraryResourceModal();
  }

  hideError = () => {
    const { originalResourceName, resourceName } = this.state;
    const { isEdit } = this.props;
    const resourceNameVal = isEdit ? originalResourceName : resourceName;
    this.setState({ errorMsg: null, resourceName: resourceNameVal });
  }

  render() {
    const { close, createNewLibraryResourceOpen, isEdit, isReadOnly = false, selectedResourceType, isInCourse = false, t } = this.props;
    const {
      errorMsg, isSaving, isValid, resourceDescription, resourceName, resourceUnitName,
      resourceTemplate, selectedModeType, teacherCanChangeMode, templateOptions
    } = this.state;
    const { ModalBanner, SCCheckbox, SCRadio } = this;
    const typeLabel = selectedResourceType === 'assessment' ? 'assessmentLabel' : 'assessmentBankLabel';
    const headerLabel = (isEdit || isReadOnly) ? `${t(typeLabel)} ${t('modalEditLabel')}` : `${t('modalCreateLabel')} ${t(typeLabel)}`;
    const inputLabelSubText = selectedResourceType === 'assessment' ? `${t('nameLabelSubText')} ${t(typeLabel)}.` : `${t('nameLabelSubText')} ${t(typeLabel)}. ${t('nameLabelSubTextPostfix')}`;
    return (
      <Modal className='create-new-library-resource-modal' open={createNewLibraryResourceOpen} size='tiny'>
        <ModalBanner
          label={headerLabel}
          onClose={close} />
        <Modal.Content>
          {/* <div className='description-text'>{t('descriptionText')}</div> */}
          <div className='inputLabelText'>{t('nameLabelText')}</div>
          <div className='inputLabelSubText'>{inputLabelSubText}</div>
          <Form.Field className='create-new-resource-field'>
            <Form.Input
              className='inputText'
              disabled={isReadOnly}
              name='resourceName'
              onChange={this.handleChangeResourceName}
              placeholder={t('inputPlaceholderText')}
              type='text'
              value={resourceName} />
            {errorMsg ? (
              <div className='error-message-wrapper'>
                <Message
                  className='create-library-resource-modal-error-msg'
                  content={`${errorMsg}`}
                  error
                  visible={errorMsg !== null} />
              </div>
            ) : null}
          </Form.Field>
          <div className='inputLabelText'>{t('descriptionLabelText')}</div>
          <div className='inputLabelSubText'>{t('descriptionLabelSubText')}</div>
          <Form.Field className='create-new-resource-field'>
            <Form.Input
              className='inputText'
              disabled={isReadOnly}
              name='resourceDescription'
              onChange={this.handleChangeResourceDescription}
              placeholder={t('inputPlaceholderText')}
              type='text'
              value={resourceDescription} />
          </Form.Field>
          {(selectedResourceType === 'assessment-bank' && !isEdit) && (
            <>
              <div className='inputLabelText'>{t('unitNameLabelText')}</div>
              <div className='inputLabelSubText'>{t('unitNameLabelSubText')}</div>
              <Form.Field className='create-new-resource-field'>
                <Form.Input
                  className='inputText'
                  disabled={isReadOnly}
                  name='resourceUnitName'
                  onChange={this.handleChangeResourceUnitName}
                  placeholder={t('defaultUnitPlaceholderText')}
                  type='text'
                  value={resourceUnitName} />
              </Form.Field>
            </>
          )}
          {selectedResourceType === 'assessment' && (
            <>
              <div className='inputLabelText'>{t('templateLabelText')}</div>
              <div className='inputLabelSubText'>{t('templateLabelSubText')}</div>
              <Form.Field className='create-new-resource-field'>
                <Dropdown
                  disabled={isReadOnly}
                  fluid
                  name='template-select'
                  onChange={this.handleChangeResourceTemplate}
                  options={templateOptions}
                  placeholder={t('templateLabelText')}
                  search
                  selection
                  value={resourceTemplate} />
              </Form.Field>
              {isInCourse && (
                <>
                  <div className='inputLabelText'>{t('modeLabelText')}</div>
                  <div className='inputLabelSubText'>{t('modeLabelSubText')}</div>
                  <Form.Field className='create-new-resource-field'>
                    <SCRadio
                      checked={selectedModeType === 'primary'}
                      disabled={isReadOnly}
                      label={t('usePrimaryModeLabel')}
                      name='exportGroup'
                      onChange={this.handleChangeModeType}
                      value='primary' />
                    <SCRadio
                      checked={selectedModeType === 'alternate'}
                      disabled={isReadOnly}
                      label={t('useAlternateModeLabel')}
                      name='exportGroup'
                      onChange={this.handleChangeModeType}
                      value='alternate' />
                    <SCCheckbox
                      checked={teacherCanChangeMode === true}
                      disabled={isReadOnly}
                      label={t('teacherCanChangeModeLabel')}
                      onChange={this.handleTeacherCanChangeMode}
                      readOnly />
                  </Form.Field>
                </>
              )}
            </>
          )}
        </Modal.Content>
        <Modal.Actions>
          <Button basic onClick={() => { this.closeCreateNewLibraryResourceModal(); }} primary>{t('cancelButtonLabel', 'Cancel')}</Button>
          {!isReadOnly && (
            <Button
              disabled={!isValid}
              onClick={() => {
                this.setState({ isSaving: true });
                this.createOrEditLibraryResource();
              }}
              primary>
              {isEdit ? (isSaving ? <Loader active inline size='tiny' /> : t('saveButtonLabel', 'Save')) : (isSaving ? <Loader active inline size='tiny' /> : t('createButtonLabel', 'Create'))}
            </Button>
          )}
        </Modal.Actions>
      </Modal>
    );
  }
}

SatCoreRegister('CreateNewLibraryResourceModal', CreateNewLibraryResourceModal);
